export enum LibraryQuickListFilters {
  NEW = 'new',
  PINNED = 'pinned',
  RECENTLY_OPENED = 'recently-opened',
  RECOMMENDED = 'recommended'
}
